import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { Animated, StyleSheet } from 'react-native';
import shadow from './styles/shadow';
import overlay from './styles/overlay';
import { white } from "./styles/colors";
/**
 * Surface is a basic container that can give depth to an element with elevation shadow.
 * On dark theme with `adaptive` mode, surface is constructed by also placing a semi-transparent white overlay over a component surface.
 * Overlay and/or shadow can be applied by specifying the `elevation` property both on Android and iOS.
 *
 * <div class="screenshots">
 *   <img src="screenshots/surface-1.png" />
 *   <img src="screenshots/surface-2.png" />
 *   <img src="screenshots/surface-3.png" />
 * </div>
 *
 * <div class="screenshots">
 *   <img src="screenshots/surface-dark-1.png" />
 *   <img src="screenshots/surface-dark-2.png" />
 * </div>
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { PnmacSurface, PnmacText } from 'pnmac-universal-components';
 * import { StyleSheet } from 'react-native';
 *
 * const MyComponent = () => (
 *   <PnmacSurface style={styles.surface}>
 *      <PnmacText>Surface</PnmacText>
 *   </PnmacSurface>
 * );
 *
 * export default MyComponent;
 *
 * const styles = StyleSheet.create({
 *   surface: {
 *     padding: 8,
 *     height: 80,
 *     width: 80,
 *     alignItems: 'center',
 *     justifyContent: 'center',
 *     elevation: 4,
 *   },
 * });
 * ```
 */
var PnmacSurface = /** @class */function (_super) {
  __extends(PnmacSurface, _super);
  function PnmacSurface() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacSurface.prototype.render = function () {
    var _a = this.props,
      style = _a.style,
      theme = _a.theme,
      rest = __rest(_a, ["style", "theme"]);
    var flattenedStyles = StyleSheet.flatten(style) || {};
    var elevation = flattenedStyles.elevation || 4;
    return /*#__PURE__*/React.createElement(Animated.View, __assign({}, rest, {
      style: [{
        backgroundColor: "#FFFFFF"
      }, 0 && shadow(elevation), style]
    }));
  };
  return PnmacSurface;
}(React.Component);
export default PnmacSurface;